import { Row, Col } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import { InfoCircleOutlined } from '@ant-design/icons'

import InputNormal from '@/components/shared-components/form/Input'
import InstantUploadGeneral from '@/components/shared-components/form/InstantUploadGeneral'
import DatePickerInput from '@/components/shared-components/form/DatePicker'
import { UeCountries } from "@/config/StatiMembriDell'UE"

const Attachments = (props) => {
  const { t } = useTranslation()

  const {
    profile,
    formValues,
    setFormValues,
    errors,
    national_id_files,
    setNational_id_files,
    tax_health_card_files,
    setTax_health_card_files,
    residence_files,
    setResidence_files,
  } = props

  return (
    <>
      <Row className='form-type_5' gutter={[16, 16]}>
        <Col span={24}>
          <div>
            <label>
              {t('Documento di riconoscimento')}{' '}
              <span>
                {t("(Carta d'identita fronte e retro / Passaporto / Patente)")}
              </span>{' '}
              & {t('data di scadenza')}
              <InfoCircleOutlined
                className={`text-danger ms-2 ${
                  !errors.national_id_files && !errors.nid_expire_at
                    ? 'hidden'
                    : ''
                }`}
              />
            </label>
            <Row
              gutter={[16, 16]}
              className='bg-white border border-[#DDD] rounded-lg p-16'
            >
              <Col xs={24} sm={12}>
                <InstantUploadGeneral
                  uploadedFiles={profile?.national_id_files}
                  uploadedFilesType='national_id_file'
                  files={national_id_files}
                  setFiles={(files) => setNational_id_files(files)}
                />
              </Col>
              <Col xs={24} sm={12}>
                <DatePickerInput
                  validation='gt'
                  dateValue={formValues.nid_expire_at}
                  setDateValue={(dateString) =>
                    setFormValues({ ...formValues, nid_expire_at: dateString })
                  }
                />
              </Col>
            </Row>
            <small className='text-danger'>{errors.national_id_files}</small>
          </div>
        </Col>

        {formValues.nationality !== 'Italia' &&
          !UeCountries.includes(formValues.nationality) && (
            <Col xs={24}>
              <div>
                <label>
                  {t('Permesso di soggiorno')} & {t('data di scadenza')}
                  <InfoCircleOutlined
                    className={`text-danger ms-2 ${
                      !errors.residence_files && !errors.residence_expire_at
                        ? 'hidden'
                        : ''
                    }`}
                  />
                </label>
                <Row
                  gutter={[16, 16]}
                  className='bg-white border border-[#DDD] rounded-lg p-16'
                >
                  <Col xs={24} sm={12}>
                    <InstantUploadGeneral
                      uploadedFiles={profile?.residence_files}
                      uploadedFilesType='residence_file'
                      files={residence_files}
                      setFiles={(files) => setResidence_files(files)}
                    />
                  </Col>
                  <Col xs={24} sm={12}>
                    <DatePickerInput
                      validation='gt'
                      dateValue={formValues.residence_expire_at}
                      setDateValue={(dateString) =>
                        setFormValues({
                          ...formValues,
                          residence_expire_at: dateString,
                        })
                      }
                    />
                  </Col>
                </Row>
                <small className='text-danger'>{errors.residence_files}</small>
              </div>
            </Col>
          )}

        <Col xs={24}>
          <div>
            <label>
              {t('Codice Fiscale / Tessera Sanitaria')}
              <InfoCircleOutlined
                className={`text-danger ms-2 ${
                  !errors.tax_code_health_card_files && !errors.serial_number
                    ? 'hidden'
                    : ''
                }`}
              />
            </label>

            <Row
              gutter={[16, 16]}
              className='bg-white border border-[#DDD] rounded-lg p-16'
            >
              <Col xs={24} sm={12}>
                <InstantUploadGeneral
                  uploadedFiles={profile?.tax_code_health_card_files}
                  uploadedFilesType='tax_health_card_file'
                  files={tax_health_card_files}
                  setFiles={(files) => setTax_health_card_files(files)}
                />
              </Col>
              <Col xs={24} sm={12}>
                <InputNormal
                  placeholder='Inserisci codice fiscale'
                  name='serial_number'
                  value={formValues.serial_number}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      serial_number: e.target.value,
                    })
                  }
                />
              </Col>
            </Row>
            <small className='text-danger'>
              {errors.tax_code_health_card_files}
            </small>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default Attachments
